
import { useState } from "react";
import { withRouter } from "react-router-dom";
import "./index.less";

const InternalUse = (props) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="internal-use">
      {isLoading && (
        <div className="loading-container">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>正在加载系统登录门户...</p>
          </div>
        </div>
      )}
      <iframe 
        src="/showMenu.html" 
        width="100%" 
        height="100vh"
        frameBorder="0"
        title="系统登录门户"
        style={{ border: 'none', display: isLoading ? 'none' : 'block' }}
        onLoad={handleIframeLoad}
      />
    </div>
  );
};

export default withRouter(InternalUse);
